import { defineStore } from "pinia";
import { IQualityReview, IQualityReviewRequest, IQualityReviewResponse, QualityReview } from "src/models/quality";
import { erebus } from "boot/axios";
import { AxiosResponse } from "axios";

export const useQualityStore = defineStore({
  id: "quality",
  state: () => ({
    qualityReviews: [] as IQualityReview[]
  }),
  getters: {
    getCaseQualityReviews: (state) => (caseID: number): IQualityReview[] => {
      return state.qualityReviews.filter((r) => r.caseID === caseID);
    }
  },
  actions: {
    locallySaveQualityReview(review: IQualityReview): void {
      this.qualityReviews = this.qualityReviews.filter((r) => r.ID !== review.ID);
      this.qualityReviews.push(review);
    },
    locallySaveQualityReviews(reviews: IQualityReview[]): void {
      this.qualityReviews = this.qualityReviews.filter((r) => !reviews.some((newR) => newR.ID === r.ID));
      this.qualityReviews.push(...reviews);
    },
    async fetchQualityReview(reviewID: number): Promise<void> {
      const res: AxiosResponse<IQualityReviewResponse, void> = await erebus.get(`/quality/review/${reviewID}`);
      const review: IQualityReview = new QualityReview(res.data);
      this.locallySaveQualityReview(review);
    },
    async fetchCaseQualityReviews(caseID: number): Promise<void> {
      const res: AxiosResponse<IQualityReviewResponse[], void> = await erebus.get(`/quality/case/${caseID}/reviews`);
      const reviews: IQualityReview[] = res.data.map((r) => new QualityReview(r));
      this.locallySaveQualityReviews(reviews);
    },
    async postQualityReview(review: IQualityReviewRequest): Promise<void> {
      await erebus.post("/quality/review", review);
    }
  }
});